import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { lazy } from 'react';


import ProtectedRoutes from './ProtectRoutes';


const Chat = lazy(() => import('./Pages/Chat'));
const Login = lazy(() => import('./Pages/Login'));
const PageNotFound = lazy(() => import('./Pages/PageNotFound'));
const ErrorPage = lazy(() => import('./Pages/Error'));

// Function to dynamically determine the basename
const getBasename = () => {
  const path = window.location.pathname;
  const subdir = path.split('/')[1];
  return subdir ? `/${subdir}` : '/';
};


const router = createBrowserRouter([

  {
    path: "/",
    element: <ProtectedRoutes />,
    errorElement: <ErrorPage />,
    children: [
      {
        errorElement: <ErrorPage />,
        children: [
          { index: true, element: <Chat /> },
          { path: "/chat", element: <Chat /> },
          // { index: true, element: <DataGridDemo/>}
          /* the rest of the routes */
        ],
      },
    ],
  },

  {
    path: '/login',
    element: <Login />,
    errorElement: <ErrorPage />,
  },

  {
    path: "*",
    element: <PageNotFound />,
    errorElement: <ErrorPage />,
  }
],
  { basename: getBasename() }

);

export default function Router() {
  return <RouterProvider router={router} />
}